import React, { useEffect, useRef, useState } from "react";
import commonNetwork from "../../../common/api/commonNetwork";
import CheckedRadio from "./CheckedRadio";
import { CustomerSelectBox, Input, SearchInput } from "../Elements";
import { PaymentCustomerInformationType } from "../../../common/types";
import useOutsideClick from "../../../hooks/useClickOutside";
import GroupTitle from "./GroupTitle";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../store/RootState";
import { isInputValidationError } from "../../../common/helpers/paymentHelpers";
import { isValidEmailAddress } from "../../../common/helpers/globalHelpers";
import { IS_BANK_USER } from "../../../constants/storageKeys";

type CustomerSelectTypes = "fromSelect" | "manuelInput";
type CustomerTypeSelectRadio = {
    type: CustomerSelectTypes,
    text: string
}

const customerSelectTypeRadioList: Array<CustomerTypeSelectRadio> = [
    {
        type: "fromSelect",
        text: "Mevcut Müşteri"
    },
    {
        type: "manuelInput",
        text: "Yeni Müşteri"
    }
];


type Props = {
    customerId?: number,
    selectedCustomerInfo: PaymentCustomerInformationType,
    setSelectedCustomerInfo: (item: PaymentCustomerInformationType) => void,
    clearCustomer: (isManuelInput: boolean) => void,
    isCustomerTypeVisible: boolean,
    isOnlyManuelCustomer: boolean
}
const CustomerSelect = React.memo(({ customerId, selectedCustomerInfo, setSelectedCustomerInfo, clearCustomer,
    isCustomerTypeVisible, isOnlyManuelCustomer }: Props) => {


    const { validationErrors } = useSelector((state: RootStateType) => state.paymentPage);
    const isBankUser = localStorage.getItem(IS_BANK_USER) == "true";

    const selectboxRef = useRef(null);
    const isSelectCustomer = useRef(false);
    const [customerList, setCustomerList] = useState<Array<PaymentCustomerInformationType>>([]);
    const [customerSelectType, setCustomerType] = useState<CustomerSelectTypes>("fromSelect");
    const [searchValue, setSearchValue] = useState("");
    const [isShowCustomerDropdown, setIsShowCustomerDropdown] = useState(false);
    const [customerListLoading, setCustomerlistLoading] = useState(true);


    useEffect(() => {
        selectCustomerPaymentCustomers();
    }, []);


    const selectCustomerPaymentCustomers = async () => {
        try
        {
            if (!isSelectCustomer.current && !isBankUser) {
            const result = await commonNetwork.get("/customer/all-from-select");
            if (result.isSuccess) {
                isSelectCustomer.current = true;
                setCustomerList(result.data);
                if (result.data && result.data?.length ==1) {
                    onSelectCustomer(result.data[0]);
                }
            }
        }
        } catch (error) {
            console.warn("Müşteri listesi alınamadı: ", error);
        } finally{
            setCustomerlistLoading(false);
        }        
    }


    const showCustomerDropdown = () => {
        if (!isShowCustomerDropdown) {
            setIsShowCustomerDropdown(true)
        }
    }
    const hideCustomerDropdown = () => setIsShowCustomerDropdown(false);

    const onSelectCustomer = (value: PaymentCustomerInformationType) => {

        setSelectedCustomerInfo(value);
        hideCustomerDropdown();
    }
    const onChangeCustomerInformation = (event: any) => {

        setSelectedCustomerInfo({
            ...selectedCustomerInfo,
            [event.target.name]: event.target.value
        });
    }

    const onClickCustomerType = (type: CustomerSelectTypes) => {
        setCustomerType(type);
        clearCustomer(type == "manuelInput");

        setSearchValue("");
    }



    const CustomerSelectType = () => (
        <div className=" w-full bg-white ">


            <div className=" w-full justify-between items-center flex  mt-4">
                {customerSelectTypeRadioList.map((item, index) => {
                    const isSelected = customerSelectType == item.type;
                    const selectedTextClass = isSelected ? "text-slate-900" : "text-slate-500";
                    const selectedBorder = isSelected ? "border-blue-700" : "border-gray-200";

                    return (
                        <button key={index + "customerSelectTypeRadioList"}
                            onClick={() => onClickCustomerType(item.type)}
                          
                            className={`w-full h-[60px] p-3 bg-white cursor-pointer rounded-lg border-2 ${index == 0 && "mr-2"} ${selectedBorder} justify-between items-center flex`}>
                            <div className={`${selectedTextClass} text-[13px] font-normal font-['Helvetica'] leading-none tracking-tight`}>
                                {item.text}
                            </div>
                            {isSelected && <CheckedRadio />}
                        </button>
                    );
                })}
            </div>
        </div>
    );

    useOutsideClick(selectboxRef, hideCustomerDropdown);
 
    const isCustomerSelect = selectedCustomerInfo.customerId && selectedCustomerInfo.customerId;
    return (
        <div className="mt-6">
            <GroupTitle title="Müşteri Bilgileri" />
            {isCustomerTypeVisible && (
                <CustomerSelectType />
            )}
            <div className=" ">
                {(customerSelectType == "fromSelect" && isOnlyManuelCustomer != true) ? (
                    <div className={`relative w-full `} ref={selectboxRef}>
                        <div
                            className={`p-4 border border-light-border mt-6 
                            ${isShowCustomerDropdown ? "shadow-lg border-b-0 rounded-t-lg" : "rounded-lg"} 
                            ${(isCustomerSelect && isShowCustomerDropdown != true) && "!border-none !p-0"} 
                            ${isInputValidationError("customerId", validationErrors) && !isCustomerSelect && "!border-error"}`}>
                            <SearchInput placeholder={isCustomerSelect ? "Müşteri Değiştir" : "Müşteri Ara"}
                                onChange={setSearchValue}
                                onClick={showCustomerDropdown}
                            />
                        </div>


                        <CustomerSelectBox customerList={customerList} onSelect={onSelectCustomer}
                            selectedCustomer={selectedCustomerInfo?.customerId} show={isShowCustomerDropdown} hide={hideCustomerDropdown}
                            searchValue={searchValue} isLoading={customerListLoading}
                        />
                    </div>
                ) : (
                    <div className="w-full mt-6">

                        <Input
                            type="text"
                            onChange={onChangeCustomerInformation}
                            name={"customerName"}
                            placeholder="Müşteri Adı"
                            className="bg-white"
                            error={isInputValidationError("customerName", validationErrors) && !selectedCustomerInfo.customerName}
                        />
                        <Input
                            type="text"
                            onChange={onChangeCustomerInformation}
                            name={"email"}
                            placeholder="Müşteri E-posta"
                            className="bg-white mt-3"
                            error={isInputValidationError("email", validationErrors) && !isValidEmailAddress(selectedCustomerInfo.customerName)}

                        />
                        <Input
                            type="text"
                            onChange={onChangeCustomerInformation}
                            name={"phone"}
                            placeholder="Müşteri Telefon"
                            className="bg-white mt-3"
                                mask="(999) 999 99 99"
                        />
                        <Input
                            type="text"
                            onChange={onChangeCustomerInformation}
                            name={"taxOffice"}
                            placeholder="Vergi Dairesi"
                            className="bg-white mt-3"
                        />
                        <Input
                            type="text"
                            onChange={onChangeCustomerInformation}
                            name={"taxCode"}
                            placeholder="Vergi Numarası"
                            className="bg-white mt-3"
                            mask="9999999999"
                        />
                        <Input
                            type="text"
                            onChange={onChangeCustomerInformation}
                            name={"tccode"}
                            placeholder="TC Kimlik No."
                            className="bg-white mt-3"
                            mask="99999999999"
                        />
                    </div>
                )}

            </div>

        </div>
    );
})
export default CustomerSelect;